import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  YMaps,
  Map,
  GeolocationControl,
  FullscreenControl,
  ZoomControl,
  SearchControl,
} from 'react-yandex-maps';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import _some from 'lodash/some';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _orderBy from 'lodash/orderBy';
import _isEqual from 'lodash/isEqual';
import _debounce from 'lodash/debounce';
import _compact from 'lodash/compact';
import _find from 'lodash/find';

import * as restaurantActions from '../../state/modules/restaurant/actions';
import { mapLocale } from '../../state/modules/map/selectors';
import config from '../../config';

import Spinner from '../Spinner';
import Paper from '../Paper';
import Form from '../Form';

import ClearIcon from '../../icons/close.svg';
import SearchIcon from '../../icons/search.svg';
import clockIcon from './assets/clock-small.svg';

import MapInfoWindow from './MapInfoWindow';
import MapPlacemarks from './MapPlacemarks';
import MapPolygons from './MapPolygons';
import MapRouteWindow from './MapRouteWindow';
// import locationIcon from './assets/location-red.svg';

import styles from './ContactsMap.styl';

const cx = classNames.bind(styles);

/* if (this.props.delivery_type === 'delivery' && ymaps) {
  const { restaurant_point, delivery_point } = this.props;

  ymaps
    .route(
      [[restaurant_point[1], restaurant_point[0]], [delivery_point[1], delivery_point[0]]],
      {
        mapStateAutoApply: true,
      },
    )`
    .then(route => {
      route.getPaths().options.set({
        strokeColor: 'c21313',
        strokeWidth: 4,
        opacity: 0.6,
      });
      this.map.geoObjects.add(route.getPaths());
    });
} */

class ContactsMap extends PureComponent {
  static defaultProps = {
    className: '',
    mapState: {
      controls: [],
    },
  };

  static propTypes = {
    className: PropTypes.string,
    center: PropTypes.array.isRequired,
    mapState: PropTypes.object.isRequired,
    isPhone: PropTypes.bool.isRequired,
    restaurant: PropTypes.object,
    intl: PropTypes.object,
    mapLocale: PropTypes.string,
    userCity: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  };

  constructor(props) {
    super(props);
    this.debouncedPolygonClick = _debounce(this.polygonClick, 100);
    this.mapPolygons = [];
  }

  state = {
    selectedPolygonId: undefined,
    selectedRestaurantId: undefined,
    deliveryGroups: [],
    isMarkerHover: false,
    allMarkersVisible: false,
    hintLayout: null,
    isLoaded: false,
    uniqueCategory: undefined,
    activeCategory: 'day',
    activeTab: 'day',
    searchValue: '',
    searchPopupHidden: false,
    isNoResultMessage: false,
    tempSelectedMap: {
      selectedPolygonId: undefined,
      selectedRestaurantId: undefined,
    },
    windowSection: 'info',
    routingMode: 'auto',
    searchCoordinates: null,
  };

  componentDidMount() {
    const { restaurant } = this.props;

    if (restaurant.isLoaded) {
      this.getUniqueCategory(restaurant.list);
      this.getDeliveryGroups(restaurant.list, this.state.activeCategory);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.restaurant.isLoaded && !_isEqual(prevProps.restaurant, this.props.restaurant)) {
      this.getUniqueCategory(this.props.restaurant.list);
      this.getDeliveryGroups(this.props.restaurant.list, this.state.activeCategory);
    }
  }

  componentWillUnmount() {
    this.clearResultMessage();
  }

  showNoResultMessage = () => {
    this.clearResultMessage();
    this.setState({ isNoResultMessage: true });

    this.timer = setTimeout(() => {
      this.setState({ isNoResultMessage: false });
    }, 5000);
  };

  clearResultMessage = () => {
    this.setState({ isNoResultMessage: false, searchCoordinates: null });
    if (this.timer) {
      clearTimeout(this.timer);
    }
  };

  createSearchLayout = ymaps => {
    const then = this;
    const { userCity } = this.props;
    const isMoscow =
      ['Москва', 'Балашиха', 'Зеленоград', 'Королев', 'Мытищи', 'Щелково'].indexOf(
        userCity.name,
      ) !== -1;

    const cityName = isMoscow ? '' : `${userCity.name}, `;

    const { searchForm, searchInput } = this.refs;

    const searchLayout = ymaps.templateLayoutFactory.createClass(
      '<div class="Map__searchbox"></div>',
      {
        build() {
          searchLayout.superclass.build.call(this);
          this.searchCallback = ymaps.util.bind(this.searchCb, this);
          searchForm.addEventListener('submit', this.searchCallback, false);

          const suggestView = new ymaps.SuggestView(searchInput, {
            options: { layout: searchForm },
            provider: {
              suggest: request => {
                return ymaps.suggest(
                  `${cityName}${request}`,
                  isMoscow && {
                    boundedBy: [
                      [56.062224, 36.610939],
                      [55.132283, 38.415443],
                    ],
                  },
                );
              },
            },
          });

          suggestView.events.add('select', this.searchCallback);
        },
        clear() {
          searchLayout.superclass.clear.call(this);
        },

        searchCb(e) {
          e.preventDefault();
          const ctrl = this.getData().control;

          ctrl.search(searchInput.value).then(() => {
            then.setState({ selectedPolygonId: undefined });
          });

          ctrl.events.add('load', event => {
            const results = ctrl.getResultsArray();
            const coordinates = results?.[0]?.geometry?._coordinates;
            const query = ctrl.getRequestString();

            const geoComponents = _get(
              results,
              '0.properties._data.metaDataProperty.GeocoderMetaData.Address.Components',
              [],
            );

            const geoQuery = then.shortenGeo(geoComponents);

            if (coordinates) {
              then.setState({
                searchCoordinates: coordinates,
                routingMode: 'auto',
              });

              // then.searchPlacemark.geometry.setCoordinates(coordinates);
              // then.searchPlacemark.options.set('visible', true);
              // then.searchPlacemark.properties.set('hintContent', geoQuery || query);

              // Проверяем есть ли подходящтий полигон
              then.findAndSelectPolgon(coordinates);
            }

            then.refs.searchInput.blur();
            then.setState({ searchValue: geoQuery || query, searchPopupHidden: true });

            if (!event.get('skip') && ctrl.getResultsCount()) {
              return ctrl.showResult(0);
            }
            if (!ctrl.getResultsCount()) {
              return then.showNoResultMessage();
            }
          });
        },
      },
    );
    return searchLayout;
  };

  shortenGeo = geoComponents => {
    const localities = [];

    let hasStreet = false;
    let hasHouse = false;
    const shortAddresses = [];

    for (const geoComponent of geoComponents) {
      if (geoComponent.kind === 'street') {
        hasStreet = true;
      }
      if (geoComponent.kind === 'house') {
        hasHouse = true;
      }
      if (geoComponent.kind === 'locality') {
        localities.push(geoComponent.name);
      } else if (localities.length > 0) {
        shortAddresses.push(geoComponent.name);
      }
    }

    let query = '';

    if (hasStreet && hasHouse && shortAddresses.length) {
      query = shortAddresses.join(' ');
    } else if (localities.length > 0) {
      query = _compact([localities.join(' '), shortAddresses.join(' ')])
        .join(', ')
        .trim();
    }

    return query;
  };

  handleApiAvaliable = ymaps => {
    this.ymaps = ymaps;

    const hintL = ymaps.templateLayoutFactory.createClass(
      `<div class='Map__hint'>` +
        `<b class='Map__hintTitle'>{{ properties.name }}</b><br />` +
        `<div class='Map__hintContent'>` +
        `<img class='Map__hintIcon' src='${clockIcon}' />` +
        `<b class='Map__hintTimework'>{{ properties.object }}</b><br />` +
        `<p class='Map__hintText'>` +
        `${this.props.intl.formatMessage({ id: 'page.contacts.freeDelivery.hint' })}` +
        `&nbsp;{{ properties.sum }}&nbsp;{{properties.currency}}` +
        `</p>` +
        `</div>`,
      `</div>`,
    );
    const searchL = this.createSearchLayout(ymaps);

    setTimeout(() => {
      // this.searchPlacemark = new ymaps.Placemark(
      //   [0, 0],
      //   {},
      //   {
      //     iconLayout: 'default#imageWithContent',
      //     iconImageHref: ``,
      //     hasBalloon: false,
      //     visible: false,
      //     hasHint: true,
      //     iconImageSize: [64, 64],
      //     iconImageOffset: [-32, -32],
      //     iconContentLayout: ymaps.templateLayoutFactory.createClass(
      //       `<div class="Map__PlacemarkIcon"><img src="${locationIcon}" /></div>`,
      //     ),
      //   },
      // );

      // this.mapRef.geoObjects.add(this.searchPlacemark);

      if (this.mapRef) {
        if (this.props.isPhone) {
          this.mapRef.behaviors.disable('drag');
        }

        this.mapRef.events.add('boundschange', e => {
          if (
            e.originalEvent.newZoom >= 12 &&
            e.originalEvent.newZoom !== e.originalEvent.oldZoom
          ) {
            this.setState({ allMarkersVisible: true });
          } else if (
            e.originalEvent.newZoom < 12 &&
            e.originalEvent.newZoom !== e.originalEvent.oldZoom
          ) {
            this.setState({ allMarkersVisible: false });
          }
        });
      }
    }, 100);

    this.setState({
      hintLayout: hintL,
      searchLayout: searchL,
      isLoaded: true,
    });
  };

  getUniqueCategory = list => {
    const category = new Set();
    list.map(area => area.areas_details.map(item => category.add(item.category)));

    this.setState({ uniqueCategory: category });
  };

  getDeliveryGroups = (list, activeCategory) => {
    const deliveryGroups = [];

    list.forEach(area => {
      area.areas_details.forEach(areaDetail => {
        if (areaDetail.category === activeCategory) {
          const nonUniqDeliveryGroupIndex = deliveryGroups.findIndex(
            group => group.min_sum === areaDetail.min_sum,
          );

          if (nonUniqDeliveryGroupIndex === -1) {
            deliveryGroups.push({
              min_sum: areaDetail.min_sum,
              max_sum: areaDetail.max_sum,
              count: 1,
            });
          } else {
            deliveryGroups[nonUniqDeliveryGroupIndex].count += 1;
          }
        }
      });
    });

    const colors = [
      'rgb(0, 148, 113)',
      'rgb(194, 19, 19)',
      'rgb(242, 201, 77)',
      'rgb(161, 78, 160)',
      'rgb(150, 221, 231)',
    ];

    let sortedDeliveryGroups = _orderBy(deliveryGroups, ['count'], ['desc']);

    sortedDeliveryGroups = sortedDeliveryGroups.map((el, i) => ({
      ...el,
      color: colors[i],
      zIndex: i,
    }));

    const soSortedDeliveryGroups = _orderBy(sortedDeliveryGroups, ['min_sum'], ['asd']);

    this.setState({
      deliveryGroups: soSortedDeliveryGroups,
    });
  };

  polygonClick = (restaurantId, polygonId) => {
    const currentId = this.state.selectedPolygonId === polygonId ? undefined : polygonId;

    if (this.state.activeCategory === 'day') {
      this.setState({
        selectedPolygonId: currentId,
        windowSection: 'info',
        selectedRestaurantId: currentId ? restaurantId : undefined,
        tempSelectedMap: {
          selectedPolygonId: currentId,
          selectedRestaurantId: currentId ? restaurantId : undefined,
        },
      });
    } else {
      this.setState({
        selectedPolygonId: currentId,
        windowSection: 'info',
        selectedRestaurantId: currentId ? restaurantId : undefined,
        tempSelectedMap: {
          selectedPolygonId: undefined,
          selectedRestaurantId: undefined,
        },
      });
    }
  };

  markerHover = bool => this.setState({ isMarkerHover: bool });

  cleanSearch = () => {
    this.setState(
      {
        searchValue: '',
        searchCoordinates: null,
      },
      () => {
        this.refs.searchInput.focus();
      },
    );
  };

  switchRouteWindow = () => {
    this.setState({ windowSection: 'route' });
    this.ymapRoute();
  };

  switchInfoWindow = () => {
    return new Promise(resolve => {
      this.setState({ windowSection: 'info' }, () => {
        resolve();
      });

      if (this.mapRoute) {
        this.mapRef.geoObjects.remove(this.mapRoute);
        this.mapRoute = null;
      }
    });
  };

  ymapRoute = () => {
    const { restaurant } = this.props;
    const { searchCoordinates, searchValue, routingMode } = this.state;
    const currentRestarant = _find(restaurant.list, { id: this.state.selectedRestaurantId }) || {};

    if (searchCoordinates) {
      const pointA = searchCoordinates || searchValue; // [55.541004, 37.474103];
      const pointB = currentRestarant.coordinates;

      if (this.mapRoute) {
        this.mapRef.geoObjects.remove(this.mapRoute);
        this.mapRoute = null;
      }

      /*
      // Одиночный маршрут
      if (routingMode === 'auto') {
        this.ymaps
          .route([pointA, pointB], {
            mapStateAutoApply: true,
            routingMode: routingMode,
          })
          .then(route => {
            route.getPaths().options.set({
              strokeColor: 'c21313',
              strokeWidth: 4,
              opacity: 0.6,
            });

            this.mapRoute = route.getPaths();

            this.mapRef.geoObjects.add(this.mapRoute);
          })
          .catch(e => {});
      }
      */

      // Docs https://tech.yandex.ru/maps/jsbox/2.1/multiroute_view_options

      const multiRoute = new this.ymaps.multiRouter.MultiRoute(
        {
          referencePoints: [pointA, pointB],

          params: {
            routingMode,
          },
        },
        {
          pinVisible: false,
          viaPointVisible: false,
          wayPointVisible: false,
          // routeMarkerVisible: false, // скрывает икноку пешехода, нет в docs api
          routeStrokeWidth: 3,
          routeStrokeColor: '#444444',
          routeActiveStrokeWidth: 4,
          routeActiveStrokeColor: '#c21313',
          routeActivePedestrianSegmentStrokeColor: '#c21313',
          boundsAutoApply: true,
        },
      );

      this.mapRoute = multiRoute;
      this.mapRef.geoObjects.add(this.mapRoute);
    }
  };

  checkWorkingAtNight = item => {
    return _some(item.areas_details, { category: this.state.activeCategory });
  };

  instanceRef = ref => (this.mapRef = ref);

  handleClickTab = value => {
    if (value !== this.state.activeTab) {
      this.mapPolygons = [];
      // if (value === 'day') {

      if (this.state.windowSection === 'route') {
        this.switchInfoWindow();
      }

      this.setState(
        {
          activeTab: value,
          activeCategory: value,
          selectedPolygonId: this.state.tempSelectedMap.selectedPolygonId,
          selectedRestaurantId: this.state.tempSelectedMap.selectedRestaurantId,
          isMarkerHover: false,
        },
        () => {
          if (this.state.searchCoordinates) {
            this.findAndSelectPolgon(this.state.searchCoordinates);
          }
        },
      );
      // } else {
      //   this.setState({
      //     activeTab: value,
      //     activeCategory: value,
      //     selectedPolygonId: value,
      //     selectedRestaurantId: value,
      //     isMarkerHover: false,
      //   });
      // }

      return this.getDeliveryGroups(this.props.restaurant.list, value);
    }
    return false;
  };

  findAndSelectPolgon = coordinates => {
    let match = false;

    for (const mapPolygon of this.mapPolygons) {
      if (mapPolygon.geoObject && mapPolygon.geoObject.geometry.contains(coordinates)) {
        this.setState({ selectedRestaurantId: mapPolygon.restaurantId });

        if (this.state.selectedPolygonId !== mapPolygon.polygon_id) {
          this.polygonClick(mapPolygon.restaurantId, mapPolygon.polygon_id);
        }

        match = true;
        break;
      }

      if (!match) {
        this.setState({ selectedRestaurantId: undefined });
      }
    }
  };

  searchOnChange = input => {
    this.setState({ searchValue: input.target.value, searchPopupHidden: false });
    this.clearResultMessage();
  };

  onSelectRoutingMode = routingMode => {
    this.setState({ routingMode }, () => {
      this.ymapRoute();
    });
  };

  onClickRouteFrom = () => {
    this.switchInfoWindow().then(() => {
      this.refs.searchInput && this.refs.searchInput.focus();
    });
  };

  onFocusSearchInput = () => {
    this.setState({ searchPopupHidden: false });
  };

  getGeoObjects = mapPolygon => {
    this.mapPolygons.push(mapPolygon);
  };

  getGeolocationRef = ref => {
    if (!ref) {
      return;
    }

    this.geolocationRef = ref;

    this.geolocationRef.events.add('locationchange', event => {
      const coordinates = _get(event, 'originalEvent.geoObjects.position');

      if (coordinates) {
        this.setState({
          searchCoordinates: coordinates,
          routingMode: 'auto',
        });
        this.findAndSelectPolgon(coordinates);
      }
    });
  };

  render() {
    const {
      className,
      center,
      mapState,
      restaurant,
      userCity,
      mapLocale,
      isPhone,
      intl,
    } = this.props;
    const {
      isLoaded,
      hintLayout,
      uniqueCategory,
      deliveryGroups,
      allMarkersVisible,
      selectedPolygonId,
      isMarkerHover,
      selectedRestaurantId,
      searchValue,
      searchPopupHidden,
      windowSection,
      routingMode,
      searchCoordinates,
    } = this.state;

    const mapStateInstance = {
      ...mapState,
      zoom: userCity.zoom || 10,
      center,
    };

    const currentRestarant = _find(restaurant.list, { id: selectedRestaurantId }) || {};
    const routeTo = currentRestarant.address || '';

    return (
      <div className={cx('Map', className)}>
        <div className={cx('Map__inner')}>
          <YMaps query={{ lang: mapLocale, apikey: config.yandexApiKey }} enterprise>
            <div className={cx('Map__layout')}>
              {!isLoaded && <Spinner className={cx('Map__preloader')} />}
              <Map
                width="100%"
                height="100%"
                state={mapStateInstance}
                instanceRef={this.instanceRef}
                onLoad={this.handleApiAvaliable}
                modules={[
                  'templateLayoutFactory',
                  'suggest',
                  'util.bind',
                  'SuggestView',
                  'Placemark',
                  'multiRouter.MultiRoute',
                ]}
              >
                {restaurant.isLoaded &&
                  restaurant.list.map(item => {
                    if (this.checkWorkingAtNight(item)) {
                      return (
                        <MapPlacemarks
                          key={item.id}
                          item={item}
                          hintLayout={hintLayout}
                          selectedPolygonId={selectedPolygonId}
                          markerHover={this.markerHover}
                          allMarkersVisible={allMarkersVisible}
                        />
                      );
                    }
                    return false;
                  })}
                {restaurant.isLoaded &&
                  restaurant.list.map(item => {
                    if (this.checkWorkingAtNight(item)) {
                      return _filter(item.areas_details, {
                        category: this.state.activeCategory,
                      }).map(area => (
                        <MapPolygons
                          key={area.polygon_id}
                          restaurantId={item.id}
                          getGeoObjects={this.getGeoObjects}
                          item={area}
                          name={item.name}
                          hintLayout={hintLayout}
                          isMarkerHover={isMarkerHover}
                          selectedPolygonId={selectedPolygonId}
                          polygonClick={this.debouncedPolygonClick}
                          currency={userCity.currency.unit}
                          deliveryGroups={deliveryGroups}
                          isOpeningSoon={item.opening_soon}
                        />
                      ));
                    }
                    return false;
                  })}
                <FullscreenControl
                  options={{
                    float: 'none',
                    position: {
                      bottom: isPhone ? '36px' : '32px',
                      right: isPhone ? '20px' : '88px',
                    },
                  }}
                />
                <GeolocationControl
                  instanceRef={this.getGeolocationRef}
                  options={{
                    float: 'none',
                    position: {
                      bottom: isPhone ? '36px' : '32px',
                      right: isPhone ? '56px' : '136px',
                    },
                  }}
                />
                <ZoomControl
                  options={{
                    size: 'small',
                    float: 'none',
                    position: {
                      bottom: isPhone ? '110px' : '32px',
                      right: isPhone ? '20px' : '32px',
                    },
                  }}
                />
                <SearchControl
                  options={{
                    layout: this.state.searchLayout,
                    provider: 'yandex#map',
                    noPlacemark: true,
                  }}
                />
              </Map>
            </div>
          </YMaps>

          <Paper className={cx('Map__toolbar')}>
            <div
              className={cx('Map__searchAddress', {
                Map__searchAddress_invisible: windowSection !== 'info',
              })}
            >
              <div className={cx('Map__search', { [`Map__search_disabled`]: !isLoaded })}>
                <form ref="searchForm" action="/">
                  <div
                    className={cx('Map__searchField', {
                      Map__searchField_dirty: searchValue,
                      Map__searchPopupHidden: searchPopupHidden,
                    })}
                  >
                    <div className={cx('Map__searchIcon')}>
                      <SearchIcon width={24} height={24} />
                    </div>
                    <input
                      ref="searchInput"
                      type="text"
                      placeholder={intl.formatMessage({
                        id: 'page.contacts.searchAddress.placeholder',
                      })}
                      onFocus={this.onFocusSearchInput}
                      value={searchValue}
                      className={cx('Map__searchInput')}
                      onChange={this.searchOnChange}
                    />
                    <div className={cx('Map__searchCleaner')} onClick={this.cleanSearch}>
                      <ClearIcon width={16} height={16} />
                    </div>
                  </div>
                </form>
                {this.state.isNoResultMessage && (
                  <Form.Error
                    className={cx('Map__searchError')}
                    error={this.props.intl.formatMessage({ id: 'contactsMap.search.noResult' })}
                  />
                )}
              </div>
              {restaurant.isLoaded && (
                <MapInfoWindow
                  isPhone={isPhone}
                  selectedPolygonId={selectedRestaurantId}
                  currentRestarant={currentRestarant}
                  switchRouteWindow={this.switchRouteWindow}
                  isButtonRoute={Boolean(searchCoordinates && selectedRestaurantId)}
                />
              )}
            </div>

            {windowSection === 'route' && (
              <MapRouteWindow
                isPhone={isPhone}
                routeFrom={searchValue}
                routeTo={routeTo}
                onClickRouteFrom={this.onClickRouteFrom}
                onBack={this.switchInfoWindow}
                onSelectRoutingMode={this.onSelectRoutingMode}
                routingMode={routingMode}
              />
            )}
          </Paper>

          {uniqueCategory && isLoaded && (
            <Paper className={cx('Map__legend')}>
              <div className={cx('Map__legendGroup')}>
                <div className={cx('Map__legendTabs')}>
                  {uniqueCategory.has('day') && (
                    <div
                      className={cx('Map__legendTab', {
                        Map__legendTab_active: this.state.activeTab === 'day',
                      })}
                      onClick={() => this.handleClickTab('day')}
                    >
                      <FormattedMessage id="page.contacts.legend.tabs.day" />
                    </div>
                  )}
                  {/* uniqueCategory.has('night') && (
                      <div
                        className={cx('Map__legendTab', {
                          Map__legendTab_active: this.state.activeTab === 'night',
                        })}
                        onClick={() => this.handleClickTab('night')}>
                        <FormattedMessage id="page.contacts.legend.tabs.night" />
                      </div>
                      ) */}
                </div>
                <div className={cx('Map__legendText')}>
                  <FormattedMessage id="page.contacts.freeDelivery.label" />
                </div>
                <div className={cx('Map__legendItems')}>
                  {this.state.deliveryGroups &&
                    _map(this.state.deliveryGroups, (group, key) => (
                      <div
                        key={key}
                        className={cx('Map__legendItem')}
                        style={{ color: group.color }}
                      >
                        <div className={cx('Map__legendLabel')}>
                          &mdash;&nbsp;
                          <FormattedMessage id="amount.prefix" />
                          &nbsp;
                          {group.min_sum}&nbsp;{userCity.currency.unit}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </Paper>
          )}
        </div>
      </div>
    );
  }
}

const connector = connect(
  state => ({
    restaurant: state.restaurant,
    userCity: _get(state, 'city.userCity', {}),
    mapLocale: mapLocale(state),
    isPhone: _get(state, 'responsive.isPhone', false),
  }),
  dispatch => bindActionCreators(restaurantActions, dispatch),
);

export default injectIntl(connector(ContactsMap));
